<template>
  <div id="snackbar" :class="{active : isActive}">
    <span v-html="config.message" :class="config.type"></span>
  </div>
</template>

<script>
export default {
  props: ['config'],
  data () {
    return {
      timeoutID: 0
    }
  },
  computed: {
    // propiété qui retourne si on affiche ou pas
    isActive () {
      return this.config.display > 0
    },
    display () {
      return this.config.display
    }
  },
  watch: {
    // détecter changement sur le display et si >0 on lance le timer
    display (val) {
      if (val > 0) {
        this.setTimeout(this.config.timeout)
      }
    }
  },
  methods: {
    setTimeout (timeout) {
      // on supprime le timer précédent
      if (this.timeoutID > 0) {
        // console.log('clear timeout');
        window.clearTimeout(this.timeoutID)
        this.timeoutID = 0
      }

      // par defaut timeout a 6s
      timeout = timeout || 6000
      this.timeoutID = window.setTimeout(() => {
        // console.log('event pour mettre a false');
        this.$emit('close')
      }, timeout)
    }
  }
}
</script>

<style lang="less">
  @import '../assets/variables.less';

  #snackbar {
    position: fixed;
    left: 50%;
    bottom: 0;
    transform: translate3d(-50%,105%,0);
    opacity: 0;
    transition: transform ease-in-out .3s, opacity ease-in-out .3s;
    margin-bottom: 10px;
    width: auto;
    width:100%;
    max-width: 600px;
    z-index: 9990;
    background-color: #1c1c1c;
    border-radius: 4px;
    text-align:center;

    span
    {
      display: block;
      padding: 1em;
      font-size: 1.2em;
      color:@white;

      &.error
      {
        color: @errorColor;
      }

      small
      {
        display:block;
        margin-top:1em;
        font-size:.8em;
        font-weight:@fontLight
      }
    }

    &.active
    {
      transform: translate3d(-50%,0,0);
      opacity:1;
    }

  }
  @media only screen and (min-width: 80em) {
    #snackbar {
      left: ~"calc(50% + 14em)";
    }
  }
</style>
